/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_bf_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A man of 180 cm with a 38 cm neck and 85 cm waist is roughly 15% body fat.`)
};

const es_bf_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Un hombre de 180 cm con 38 cm de cuello y 85 cm de cintura tiene aproximadamente un 15 % de grasa corporal.`)
};

const de_bf_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ein 180 cm großer Mann mit 38 cm Halsumfang und 85 cm Taillenumfang hat etwa 15 % Körperfett.`)
};

const nl_bf_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Een man van 180 cm met een nek van 38 cm en taille van 85 cm heeft ongeveer 15% lichaamsvet.`)
};

const fr_bf_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Un homme de 180 cm avec un cou de 38 cm et une taille de 85 cm a environ 15 % de masse grasse.`)
};

const it_bf_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Un uomo di 180 cm con collo di 38 cm e vita di 85 cm ha circa il 15% di grasso corporeo.`)
};

const pt_br2_bf_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Um homem de 180 cm com 38 cm de pescoço e 85 cm de cintura tem cerca de 15% de gordura corporal.`)
};

const pt_bf_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Um homem de 180 cm com 38 cm de pescoço e 85 cm de cintura tem cerca de 15% de gordura corporal.`)
};

const ja_bf_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`身長180cm、首周り38cm、腰周り85cmの男性の体脂肪率はおよそ15%です。`)
};

const zh_bf_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`身高 180 厘米、颈围 38 厘米、腰围 85 厘米的男性，体脂率约为 15%。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const bf_ex1 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.bf_ex1(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("bf_ex1", locale)
	if (locale === "en") return en_bf_ex1(inputs)
	if (locale === "es") return es_bf_ex1(inputs)
	if (locale === "de") return de_bf_ex1(inputs)
	if (locale === "nl") return nl_bf_ex1(inputs)
	if (locale === "fr") return fr_bf_ex1(inputs)
	if (locale === "it") return it_bf_ex1(inputs)
	if (locale === "pt-BR") return pt_br2_bf_ex1(inputs)
	if (locale === "pt") return pt_bf_ex1(inputs)
	if (locale === "ja") return ja_bf_ex1(inputs)
	return zh_bf_ex1(inputs)
};